import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { ISystemWideRules } from 'src/app/shared/models/systemWideRules.model'
import * as yup from 'yup'

// Builds the time-of-day option list (value: "HH:mm:ss", label: "h:mm AM/PM"),
// mirroring the Client Setup cutoff-time pattern.
function getCutoffTimeList(minuteRange: number) {
  const times = []
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += minuteRange) {
      const hourString = hour.toString().padStart(2, '0')
      const minuteString = minute.toString().padStart(2, '0')
      const timeString = `${hourString}:${minuteString}:00`

      const hour12 = hour % 12 || 12
      const amPm = hour < 12 ? 'AM' : 'PM'
      const formattedTime = `${hour12}:${minuteString} ${amPm}`

      times.push({
        value: timeString,
        label: formattedTime,
      })
    }
  }
  return times
}

// Empty initial values: the form renders blank and is populated only from the API response,
// avoiding a flash of hardcoded default values before the data loads.
const SYSTEM_WIDE_RULES_DEFAULTS: any = {
  defaultExceptionEmailReminder: '',
  defaultCheckExceptionCutoffTime: undefined,
  defaultAchExceptionCutoffTime: undefined,
  timeZone: '',
}

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    defaultExceptionEmailReminder: yup
      .number()
      .typeError(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SystemWideRules:label.reminderEmailTime'),
        }),
      )
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t('SystemWideRules:label.reminderEmailTime'),
        }),
      )
      .min(30, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_EXCEPTION_REMINDER_EMAIL_TIME))
      .max(180, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_EXCEPTION_REMINDER_EMAIL_TIME)),
    defaultCheckExceptionCutoffTime: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('SystemWideRules:label.checkExceptionCutoffTime'),
      }),
    ),
    defaultAchExceptionCutoffTime: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('SystemWideRules:label.achExceptionCutoffTime'),
      }),
    ),
  })

  return validationSchema
}

// Normalizes a cutoff time coming from the API (e.g. "11:30:00.0000000") to the
// Select option value format "HH:mm:00" so the option label ("11:30 AM") is shown.
const normalizeCutoffTime = (time?: string): string | undefined => {
  if (!time) return time
  const [hour, minute] = time.split(':')
  if (hour === undefined || minute === undefined) return time
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}:00`
}

const formatDataBeforeSubmit = (data: ISystemWideRules): ISystemWideRules => {
  return {
    ...data,
    defaultExceptionEmailReminder: Number(data?.defaultExceptionEmailReminder),
  }
}

export {
  getCutoffTimeList,
  generateValidationSchema,
  formatDataBeforeSubmit,
  normalizeCutoffTime,
  SYSTEM_WIDE_RULES_DEFAULTS,
}
